import { render, staticRenderFns } from "./img-captcha.vue?vue&type=template&id=cc08c56c&"
import script from "./img-captcha.vue?vue&type=script&lang=js&"
export * from "./img-captcha.vue?vue&type=script&lang=js&"
import style0 from "./img-captcha.vue?vue&type=style&index=0&id=cc08c56c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports